import { Message } from 'element-ui';
/**
 * @description 复制内容到粘贴板
 * @param {*} txt 待复制内容值
 */
export const copyToClip = (txt) => {
    var input = document.createElement('input');
    input.setAttribute('value', txt);
    document.body.appendChild(input);
    // 选择对象
    input.select();
    // 执行浏览器复制命令
    document.execCommand('copy');
    document.body.removeChild(input);
    Message.success(`‘${input.value}’复制成功`);
};
export const formatMatchData = (data, dictData) => {
    if (!data.length) return [];
    data.forEach(item => {
        item.matchStatusName = dictData.MATCH_STATUS[item.matchStatus] || '';
    });
    return data;
};

export const formatMatchRule = (data, dictData) => {
    if (!data.length) return [];
    data.forEach(item => {
        item.professionalCompanyName = dictData.SYS_PROFESSIONAL_COMPANY[item.professionalCompany] || '';
        item.businessModeName = dictData.BUSINESS_MODE[item.businessMode] || '';
        item.orderTypeName = dictData.ORDER_TYPE[item.orderType] || '';
        item.deliveryTypeName = dictData.DELIVERY_TYPE[item.deliveryType] || '';
        item.taskTypeName = dictData.TASK_TYPE[item.taskType] || '';
        item.distributionFlagName = dictData.DISTRIBUTION_FLAG[item.distributionFlag] || '';
        item.distributionLastFlagName = dictData.DISTRIBUTION_LAST_FLAG[item.distributionLastFlag] || '';
    });
    return data;
};
